import { ElementNode, $applyNodeReplacement, $createParagraphNode } from 'lexical';
import './scss/Callout.scss';

export class CalloutNode extends ElementNode {
  __calloutType;

  static getType() {
    return 'callout';
  }

  static clone(node) {
    return new CalloutNode(node.__calloutType, node.__key);
  }

  constructor(calloutType = 'info', key) {
    super(key);
    this.__calloutType = calloutType;
  }

  createDOM(config) {
    const dom = document.createElement('div');
    dom.className = `callout callout-${this.__calloutType}`;
    return dom;
  }

  updateDOM(prevNode, dom) {
    // Return true if the node needs to be recreated
    if (prevNode.__calloutType !== this.__calloutType) {
      return true;
    }
    return false;
  }

  static importJSON(serializedNode) {
    const node = $createCalloutNode(serializedNode.calloutType);
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      calloutType: this.__calloutType,
      type: 'callout',
      version: 1,
    };
  }

  getCalloutType() {
    return this.__calloutType;
  }

  setCalloutType(calloutType) {
    const writable = this.getWritable();
    writable.__calloutType = calloutType;
  }

  // Allow callout to contain other nodes
  canBeEmpty() {
    return false;
  }

  // Callout can contain inline content
  isInline() {
    return false;
  }
}

export function $createCalloutNode(calloutType = 'info') {
  return $applyNodeReplacement(new CalloutNode(calloutType));
}

export function $isCalloutNode(node) {
  return node instanceof CalloutNode;
}

